import {Component, OnInit} from '@angular/core';
import {CoreConfigService} from '../../../@core/services/config.service';

@Component({
    selector: 'app-privacy-policies',
    templateUrl: './privacy-policies.component.html',
    styleUrls: ['./privacy-policies.component.scss']
})
export class PrivacyPoliciesComponent implements OnInit {

    constructor(public _coreConfigService: CoreConfigService) {
        this._coreConfigService.config = {
            layout: {
                menu: {
                    hidden: true
                },
                animation: 'none',
                customizer: false,
                enableLocalStorage: false,
                type: 'horizontal'
            }
        };
    }

    ngOnInit(): void {
    }

}
